// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__H8uBx","title":"Images45_title__3TWzg","images":"Images45_images__1Aa-w"};